<template>
  <div class="resultaten">
    <subNav :subnavstep="subnavstep"></subNav>
    <headerFeedback :step="step" />
    <div class="resultaatscherm">

      <!-- introduction block -->
      <div class="resultaatscherm__intro">
          <h2>
            Initiatiefnemer <span>{{ initiatief }}</span>
            <altspan v-if="fase">, de fase <span>{{ fase }}</span></altspan>            
            en het doel <span>{{ doel }}</span>
          </h2>
          <p>{{ doelData.description }}</p>
      </div>

      <div class="methodes-overzicht">

        <!-- Start new methode row -->
        <div class="methodes-overzicht-row"  v-for="(methode, i) in methodeData" :key="i">

          <div class="methodes-overzicht-row__description">
            <h2>{{ methode.name }}</h2>
            <div v-html="methode.description"></div>
          </div>

          <div class="methodes-overzicht-row__qualities qualities">
            <h4>Democratische waarden</h4>
            <ul class="qualities__list">
              <li v-for="(row, j) in methode.values" :key="j" class="quality-row">
                <div class="quality">
                  <span class="quality-icon" :class="cleanClass(row.waarde)"></span>
                  <span class="quality-text link">{{ row.waarde }}</span>
                  <span class="quality-scores">
                    <span class="star" v-for="n in parseInt(row.score)" :key="n"></span>
                    <span class="star star--empty" v-for="n in parseInt(5-row.score)" :key="n+10"></span>
                  </span>
                </div>
              </li>
            </ul>
          </div>
  
          <div class="methodes-overzicht-row__actions">
            <button class="roundedButton" @click="updatelightbox(methode.id,waardeindex)">{{ methode.totaltips }} tips</button>
          </div>

        </div>
        <!-- // end methode row -->

      </div>


    </div>

    <!-- lightbox -->
    <div id="lightboxLarge" class="lightbox">
      <div class="lightbox-inner">
          <span class="lightbox-close icon-close" @click="hideLightbox2()"></span>
          <div class="lightbox-inner--content" id="lightbox-content">
            <methodeLightbox 
              :method="methodeID" 
              :waarde="waardeindex" 
              :methode="methode"
              :tipsArray="tipsArray">
            </methodeLightbox>
          </div>
      </div>
    </div>
    <!-- end lightbox -->

  </div>

</template>

<script>
import subNav from '../components/subNav.vue';
import headerFeedback from '../components/headerFeedback.vue';
import methodeLightbox from './methodeLightbox.vue';
import storage from './../mixins/storage';

const ENDPOINT_NAME = 'ppw/v1/endresult';
const ENDPOINT_DETAIL = 'ppw/v1/methode';

const axios = require('axios');

export default {
  name: "eindResultaat",

  mixins: [ storage ],

  data() {
    return {
      isLoading: true,
      isEmptyResult: false,
      storedMethods: [],
      endResult: [],
      doelData: [],
      methodeData: [],
      firstrow: [],
      waardes: [],
      initiatief: '',
      fase: '',
      doel: '',
      slug: '',
      pushers: [],
      step: 'eindresultaat',
      subnavstep: 'methodes',
      // data for methodeDetailLightbox
      methode: {},
      methodeID: 0,
      waardeindex: 0,
      tipsArray: [],
      hiddenTips: [],
    };

   },

  components: {
    subNav,
    headerFeedback,
    methodeLightbox,
  },

  computed: {
    
  },
  
  methods: {

    getEndResult() {
      this.storedMethods = JSON.parse(localStorage.getItem('comparedItems'))
      // maybe better to use the slug ...
      this.doel = this.getTarget() ? this.getTarget().name : '';      
      this.initiatief = this.getInitiative() ? this.getInitiative().name : '';
      this.fase = this.getPhase() ? this.getPhase().name : '';

      let hiddenTips = JSON.parse(localStorage.getItem('hiddenTips'));

      
      const url = new URL(process.env.VUE_APP_REST_URL + ENDPOINT_NAME + '?doel='+ this.doel +'&methodes=' + this.storedMethods[0].methods) + '&hidden=' + hiddenTips;
      // fetch(url)
      axios.get(url)
        .then(r => {
          const results = r.data;
          if (!results) {
            this.endResult[0] = 'no result';
          } else {
            this.endResult = r.data;
            this.doelData = r.data.doel;
            this.methodeData = r.data.methodes;
            this.methodeID = this.methodeData[0].id
          }
          this.setMethodeDetail(this.methodeID,this.waardeindex) 
          this.methodeData.forEach((m) => { _paq.push(['trackEvent', 'method', `${m.name}`]); });
        })
        .catch(error => {
          console.warn(error);
        })
    },

    updatelightbox(method,waarde) {
      this.setMethodeDetail(method,waarde)
      document.getElementById('lightboxLarge').classList.toggle("active");
    },

    hideLightbox2: function () {
      // Hide Lightbox
      document.getElementById('lightboxLarge').classList.toggle("active");
    },

    setMethodeDetail(id,waarde) {
      const url = new URL(process.env.VUE_APP_REST_URL + ENDPOINT_DETAIL + '?method='+id);

      this.isLoading = true;
      this.isEmptyResult = false;

      // fetch(url)
      axios.get(url)
        .then(r => {
          const results = r.data
          if (!results) {
            this.methode = {}
            this.isEmptyResult = true
          } else {
            this.methodeID   = id
            this.waardeindex = waarde
            this.methode     = r.data.methode
            this.tipsArray   = this.getTips(this.methode, waarde)
          }
        })
        .catch(error => {
          console.warn(error)
        })
    },

    getTips: function (method, waardeidx) {
      let holdTips = []

      // dit toont de tips bij een democratische waarde
      if(method.values[waardeidx].tips) {
        holdTips['method'] = method.name_short
        holdTips['waarde'] = method.values[waardeidx].waarde
        holdTips['beschrijving'] = method.values[waardeidx].tekst
        holdTips['tips'] = []

        let tipsArray = method.values[waardeidx].tips;
        let tipsLength = method.values[waardeidx].tips.length;

        if (localStorage.getItem('hiddenTips')) 
          this.hiddenTips = JSON.parse(localStorage.getItem('hiddenTips'))
        else
          this.hiddenTips = []

        for(var i = 0; i < tipsLength; i++) {
          let thistip = []
          let tipIsChecked = true          
          thistip['checkboxvalue'] = 'tipcheck_' + tipsArray[i].id
          thistip['id'] = tipsArray[i].id
          thistip['value'] = tipsArray[i].value
          thistip['checked'] = tipIsChecked
          holdTips['tips'][i] = thistip
        }
        return holdTips;
      }
    },

    cleanClass(j) {
      return 'icon-'+j.replace(/ \/ /g, '');
    }
  },

  created() {
    this.slug = this.$route.params.doelSlug
  },

  mounted() {
    setTimeout(() => this.getEndResult(), 50)
  }

};

</script>

